import { render, staticRenderFns } from "./_confirmUpgrade.vue?vue&type=template&id=2bf8a20f"
import script from "./_confirmUpgrade.vue?vue&type=script&lang=js"
export * from "./_confirmUpgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports